export const FETCH_FINANCIALINFO = "financialinfo/FETCH_FINANCIALINFO";
export const FETCH_FINANCIALINFO_SUCCESS = "financialinfo/FETCH_FINANCIALINFO_SUCCESS";